<template>
  <div>
    <ul class="flex justify-between space-x-2 mb-6">
      <li v-for="(type, index) in placesTypes" :key="index">
        <div
          class="ucrs-map__place-toggle"
          :class="type.active ? 'ucrs-map__place-toggle--active' : ''"
          tabindex="0"
          :aria-label="`Mostra / nascondi ${type.name}`"
          @keyup.enter="clickPlace(index)"
          @click="clickPlace(index)"
        >
          <div class="ucrs-map__place-imgWrapper">
            <SvgIcon
              :name="type.active ? type.imgActive : type.img"
              class="max-w-9.6 max-h-9.6"
            />
          </div>
          <span class="ucrs-map__place-label">{{ type.name }}</span>
        </div>
      </li>
    </ul>
    <div
      class="rounded overflow-hidden relative"
      :class="{ 'bg-center bg-cover bg-no-repeat h-160': !activeMap }"
      :style="`background-image: ${
        activeMap
          ? 'none'
          : 'url(' + $config.baseURL + property.static_map + ');'
      }`"
    >
      <div v-show="activeMap" ref="map" class="ucrs-map__map"></div>
      <div v-if="!activeMap" class="ucrs-map__zoom-container">
        <button
          class="ucrs-map__zoom-plus"
          type="button"
          @click="loadGoogle(null)"
        />
        <button
          class="ucrs-map__zoom-minus"
          type="button"
          @click="loadGoogle(null)"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-new */
/* eslint-disable-next-line no-unused-vars */

import { unitsKeys } from '~/assets/js/mappings'

export default {
  props: {
    property: {
      type: Object,
      default: () => {
        return null
      },
    },
  },
  data() {
    return {
      activeMap: false,
      map: null,
      places: [],
      activeInfoWindow: null,
      placesTypes: {
        supermarket: {
          name: 'Supermercati',
          active: false,
          types: ['supermarket', 'shopping_mall'],
          keyword: '',
          img: 'supermarket',
          imgActive: 'supermarket-blue',
          marker:
            'https://www.unicreditres.it/assets/img/icons/supermarket-marker.png',
        },
        pharmacy: {
          name: 'Farmacie',
          active: false,
          types: ['pharmacy'],
          keyword: '',
          img: 'pharmacy',
          imgActive: 'pharmacy-blue',
          marker:
            'https://www.unicreditres.it/assets/img/icons/pharmacy-marker.png',
        },
        school: {
          name: 'Scuole',
          active: false,
          types: ['school'],
          keyword: '',
          img: 'school',
          imgActive: 'school-blue',
          marker:
            'https://www.unicreditres.it/assets/img/icons/school-marker.png',
        },
        restaurant: {
          name: 'Ristoranti',
          active: false,
          types: ['restaurant'],
          keyword: '',
          img: 'restaurant',
          imgActive: 'restaurant-blue',
          marker:
            'https://www.unicreditres.it/assets/img/icons/restaurant-marker.png',
        },
        bar: {
          name: 'Bar e locali',
          active: false,
          types: ['bar'],
          keyword: '',
          img: 'bar',
          imgActive: 'bar-blue',
          marker: 'https://www.unicreditres.it/assets/img/icons/bar-marker.png',
        },
        unicredit: {
          name: 'UniCredit S.p.A.',
          active: false,
          types: [],
          keyword: 'UniCredit',
          img: 'unicredit',
          imgActive: 'unicredit-blue',
          marker:
            'https://www.unicreditres.it/assets/img/icons/unicredit-marker.png',
        },
        parking: {
          name: 'Parcheggi',
          active: false,
          types: ['parking'],
          keyword: '',
          img: 'parking',
          imgActive: 'parking-blue',
          marker:
            'https://www.unicreditres.it/assets/img/icons/parking-marker.png',
        },
      },
    }
  },
  computed: {
    center() {
      return new google.maps.LatLng(
        this.property.location.locality.latitude,
        this.property.location.locality.longitude
      )
    },
  },
  methods: {
    loadGoogle(type) {
      if (typeof google === 'undefined') {
        const callbackName = `__gmCb${Date.now()}`
        window[callbackName] = () => {
          delete window[callbackName]
          this.onScriptLoaded(type)
        }
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = `https://maps.googleapis.com/maps/api/js?libraries=places&loading=async&callback=${callbackName}&key=${this.$config.googleMapsApiKey}`
        document.head.appendChild(script)
      } else {
        this.onScriptLoaded(type)
      }
      if (!this.activeMap) this.activeMap = true
    },
    onScriptLoaded(type) {
      if (type) {
        this.togglePlaces(type, true)
      } else {
        this.initMap(14)
        this.createMarker(true)
      }
    },
    initMap(zoom) {
      this.map = new google.maps.Map(this.$refs.map, {
        center: this.center,
        zoom,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        zoomControl: true,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.LEFT_TOP,
        },
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.LARGE,
          position: google.maps.ControlPosition.LEFT_TOP,
        },
        disableDoubleClickZoom: false,
        fullscreenControl: false,
        draggable: true,
        disableDefaultUI: true,
      })
    },
    createMarker(initial, place) {
      const title = place ? place.name : this.property.title
      const position = place ? place.geometry.location : this.center
      const icon = place ? place.marker : '/assets/img/icons/markerOver.png'
      const animation = place || !initial ? null : google.maps.Animation.DROP
      const marker = new google.maps.Marker({
        map: this.map,
        title,
        position,
        animation,
        icon,
      })

      const address = this.property.location.locality.thoroughfare.show_address
        ? `${this.property.location.locality.thoroughfare.address}${
            this.property.location.locality.thoroughfare.show_address_number
              ? ' ' +
                this.property.location.locality.thoroughfare.address_number
              : ''
          }`
        : ''

      const surface = this.property.features.surface_min
        ? `da ${this.property.features.surface_min} ${
            unitsKeys[this.property.features.surface_unit]
          }`
        : this.property.features.surface
        ? `${this.property.features.surface} ${
            unitsKeys[this.property.features.surface_unit]
          }`
        : ''

      const rooms = this.property.features.rooms_min
        ? `da ${this.property.features.rooms_min}`
        : this.property.features.rooms
        ? this.property.features.rooms
        : ''

      const imgSrc = this.property.images.length
        ? this.$utilities.imgAlias(this.property.images[0].src)
        : this.$img('/assets/img/ucrs-placeholder.png')
      const computedImgSrc = this.$img(imgSrc)

      const content = place
        ? title
        : `<div class="flex"><div class="w-32 md:w-64"><img src="${computedImgSrc}" class="w-full h-auto" /></div><div class="ml-6 w-32 md:w-64 text-navitem text-black-light"><p class="mb-2">Tipologia: ${this.property.building.property_type.name}</p><p class="mb-2">Contratto: ${this.property.transaction.contract.name}</p><p class="mb-2">Indirizzo: ${address}</p><p class="mb-2">Superficie: ${surface}</p><p class="mb-2">Locali: ${rooms}</p></div></div>`
      const infowindow = new google.maps.InfoWindow()
      infowindow.setContent(content)
      google.maps.event.addListener(
        marker,
        'click',
        (function (marker, nuxt, infowindow) {
          return function () {
            if (nuxt.activeInfoWindow === infowindow) {
              nuxt.activeInfoWindow.close()
              nuxt.activeInfoWindow = null
            } else {
              if (nuxt.activeInfoWindow) nuxt.activeInfoWindow.close()
              nuxt.activeInfoWindow = infowindow
              infowindow.open(this.map, marker)
            }
          }
        })(marker, this, infowindow)
      )
      if (initial && !place) {
        this.activeInfoWindow = infowindow
        infowindow.open(this.map, marker)
      }
      google.maps.event.addListener(
        infowindow,
        'domready',
        (function (nuxt) {
          return function () {
            const windowContainers = document.querySelectorAll('.gm-style-iw-d')
            windowContainers.forEach((container) => {
              const close = container.nextElementSibling
              if (!close) return
              close.style.outline = 'none'
              close.addEventListener('click', () => {
                nuxt.activeInfoWindow = null
              })
            })
          }
        })(this)
      )
    },
    clickPlace(type) {
      if (!this.activeMap) {
        this.loadGoogle(type)
      } else {
        this.togglePlaces(type, false)
      }
    },
    togglePlaces(type, initial) {
      if (initial) {
        this.initMap(15)
        this.createMarker(false)
      }
      this.placesTypes[type].active = !this.placesTypes[type].active
      const request = {
        type: this.placesTypes[type].types,
        keyword: this.placesTypes[type].keyword,
        location: this.map.getCenter(),
        rankBy: google.maps.places.RankBy.DISTANCE,
      }
      const service = new google.maps.places.PlacesService(this.map)
      service.nearbySearch(request, (results, status) => {
        this.setPlacesArray(
          results,
          status,
          this.placesTypes[type].active,
          this.placesTypes[type].marker,
          initial
        )
      })
    },
    setPlacesArray(results, status, active, marker, initial) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        if (active) {
          results.forEach((result) => {
            this.places.push({
              marker,
              geometry: result.geometry,
              place_id: result.place_id,
              name: result.name,
            })
          })
        } else {
          this.places = this.places.filter(
            (place) =>
              !results.find((result) => result.place_id === place.place_id)
          )
        }
      }
      if (!initial) {
        this.initMap(15)
        this.createMarker(false)
      }
      this.places.forEach((place) => {
        this.createMarker(false, place)
      })
    },
  },
}
</script>

<style lang="postcss">
@import '~/assets/css/components/map';
</style>
